import * as yup from 'yup';

export const formNovoPermissionario = yup.object().shape({
  cpfs: yup
    .string()
    .typeError('Favor informar o CPF.')
    .required('Favor informar o CPF.'),
});

